import React, { useEffect, useState } from 'react';
import {
  Container,
  ContentContainer,
  FirstItem,
  LastTableItem,
  ModalContainer,
  Edit,
  Delete,
  TemplateDetailsContainer,
  StyledInput,
  DeleteContainer,
  DeleteText,
  Background,
  SmallModalContainer,
  ModalTitleSmall,
  ButtonContainerGap,
  StyledButton,
  ButtonText,
  TextArea,
} from './FAQPage.styles';
import Sidebar from '../../components/Sidebar/Sidebar';
import Header from '../../components/Header/Header';
import { ReactComponent as RightChevron } from '../../assets/icons/chevronRight.svg';
import ModalComponent from '../../components/Modal/ModalComponent';
import Table from '../../components/Table/Table';
import TableItem from '../../components/Table/TableItem';
import { useNavigate } from 'react-router';
import { useDispatch, useSelector } from 'react-redux';
import { EmptyTable } from '../ClientsPage/ClientsPage.styles';
import { Waveform } from '@uiball/loaders';

import { useSearchParams } from 'react-router-dom';
import { notifyError, notifyErrorLeft, notifyInfo } from '../../utils/notify';
import HamburgerSidebar from '../../components/HamburgerSidebar/HamburgerSidebar';
import { TableBodyRow } from '../../components/Table/Table.styles';
import { createVendorFaQ, deleteVendorFaQ, getAllVendorFaQ, updateVendorFaQ } from '../../store/slice/faq/asyncThunks';
import {
  selectAllFAQ,
  selectCreateVendorFaQPending,
  selectDeleteVendorFaQPending,
  selectGetAllVendorFaQPending,
  selectGetVendorFaQForUserPending,
  selectUpdateVendorFaQPending,
} from '../../store/slice/faq/slice';
import { dateFormatter } from '../../utils/utils';

const tableHeader = [
  {
    label: 'Question',
    sortable: true,
    key: 'question',
  },
  {
    label: 'Answer',
    sortable: true,
    key: 'answer',
  },
  {
    label: 'Created At',
    sortable: true,
    key: 'createdAt',
  },
  {
    label: '',
    sortable: true,
    key: 'chevron',
  },
];

const TemplatesPage = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  let [searchParams] = useSearchParams();
  const pageParam = searchParams.get('page');

  const { data, total, perPage } = useSelector(selectAllFAQ);

  const loading = useSelector(selectGetAllVendorFaQPending);
  const loadingById = useSelector(selectGetVendorFaQForUserPending);
  const createLoading = useSelector(selectCreateVendorFaQPending);
  const editLoading = useSelector(selectUpdateVendorFaQPending);
  const deleteLoading = useSelector(selectDeleteVendorFaQPending);

  const [selectedId, setSelectedId] = useState(null);

  useEffect(() => {
    dispatch(getAllVendorFaQ({ page: pageParam }))
      .unwrap()
      .then()
      .catch(err => {
        console.log(err);
        notifyError(err.message);
      });
  }, [dispatch, pageParam]);

  const changePage = page => {
    navigate({
      pathname: '/faq',
      search: `?page=${page}`,
    });
    dispatch(getAllVendorFaQ({ page }));
  };

  const [isModalOpenCreate, setIsModalOpenCreate] = useState(false);
  const [isModalOpenSelect, setIsModalOpenSelect] = useState(false);
  const [question, setQuestion] = useState('');
  const [answer, setAnswer] = useState('');
  const [selectedQuestion, setSelectedQuestion] = useState('');
  const [selectedAnswer, setSelectedAnswer] = useState('');
  const [edit, setEdit] = useState(false);
  const [areYouSureModal, setAreYouSureModal] = useState(false);
  const [isVisible, setIsVisible] = useState(areYouSureModal);
  const [faq, setFaq] = useState(null);

  const onFAQDetails = item => {
    if (item) {
      setFaq(item);
      setIsModalOpenSelect(true);
    }
  };

  useEffect(() => {
    setSelectedId(faq?.id);
    setSelectedQuestion(faq?.question);
    setSelectedAnswer(faq?.answer);
  }, [faq]);

  useEffect(() => {
    let timer;
    if (areYouSureModal) {
      setIsVisible(true);
    } else {
      timer = setTimeout(() => setIsVisible(false), 250);
    }

    return () => clearTimeout(timer);
  }, [areYouSureModal]);

  const openModalCreate = () => {
    setIsModalOpenCreate(true);
  };

  const closeModalCreate = () => {
    setQuestion('');
    setAnswer('');
    setIsModalOpenCreate(false);
  };

  const closeModalSelect = () => {
    setSelectedId(null);
    setSelectedQuestion('');
    setSelectedAnswer('');
    setFaq(null);
    setIsModalOpenSelect(false);
  };

  const handleCreate = () => {
    dispatch(createVendorFaQ({ question, answer }))
      .unwrap()
      .then(() => {
        closeModalCreate();
        notifyInfo('Successfully created faq');
      })
      .catch(err => {
        console.log(err);
        notifyErrorLeft(err.message);
      });
  };

  const handleDelete = id => {
    dispatch(deleteVendorFaQ(id))
      .unwrap()
      .then(() => {
        closeModalSelect();
        notifyInfo('Successfully deleted faq');
      })
      .catch(err => {
        console.log(err);
        notifyErrorLeft(err.message);
      });
  };

  const handleEdit = () => {
    dispatch(updateVendorFaQ({ id: selectedId, answer: selectedAnswer, question: selectedQuestion }))
      .unwrap()
      .then(() => {
        closeModalSelect();
        notifyInfo('Successfully updated faq');
      })
      .catch(err => {
        console.log(err);
        notifyErrorLeft(err.message);
      });
  };

  return (
    <Container>
      <Sidebar />
      <HamburgerSidebar />
      <ContentContainer>
        <Header title={"Your FAQ's"} buttonAdd onButtonClick={openModalCreate} buttonText={'New FAQ'} />

        {!loading ? (
          <Table
            headerInformation={tableHeader}
            totalCount={total}
            currentPage={+pageParam}
            setPage={changePage}
            perPage={perPage}
            noDataContent="Upload your client’s most frequently asked questions here"
            dataLoading={false}
            lastColumnAligned
            chevron>
            {data.map(row => {
              return (
                <TableBodyRow
                  key={row.id}
                  onClick={() => {
                    onFAQDetails(row);
                  }}>
                  <FirstItem data={row.question} />
                  <TableItem data={row?.answer?.length > 30 ? row?.answer?.slice(0, 30) + '...' : row?.answer} />
                  <TableItem data={dateFormatter(row?.createdAt)} />
                  <LastTableItem
                    $chevron
                    data={
                      loadingById && row.id === selectedId ? (
                        <Waveform size={20} lineWeight={3} speed={1} color="black" />
                      ) : (
                        <RightChevron />
                      )
                    }
                  />
                </TableBodyRow>
              );
            })}
          </Table>
        ) : (
          <EmptyTable>
            <Waveform size={40} lineWeight={3.5} speed={1} color="black" />
          </EmptyTable>
        )}
      </ContentContainer>

      <ModalComponent
        isOpen={isModalOpenCreate}
        onClose={closeModalCreate}
        title={'New FAQ'}
        onCreate={handleCreate}
        createDisabled={createLoading || !question || !answer}
        rightButtonTitle={'Create'}
        width={'800px'}
        loading={createLoading}>
        <ModalContainer>
          <TemplateDetailsContainer>
            <StyledInput placeholder="Question" value={question} onChange={e => setQuestion(e.target.value)} />
            <TextArea placeholder="Answer" value={answer} onChange={e => setAnswer(e.target.value)} />
          </TemplateDetailsContainer>
        </ModalContainer>
      </ModalComponent>

      <ModalComponent
        rightIcon={<Edit onClick={() => setEdit(!edit)} />}
        isOpen={isModalOpenSelect}
        onClose={closeModalSelect}
        title={'Edit FAQ'}
        onCreate={handleEdit}
        createDisabled={selectedQuestion === faq?.question && selectedAnswer === faq?.answer}
        rightButtonTitle={'Submit'}
        width={'800px'}
        loading={editLoading}>
        <ModalContainer>
          <TemplateDetailsContainer>
            <StyledInput
              value={selectedQuestion}
              disabled={!edit}
              onChange={e => setSelectedQuestion(e.target.value)}
            />
            <TextArea disabled={!edit} value={selectedAnswer} onChange={e => setSelectedAnswer(e.target.value)} />
          </TemplateDetailsContainer>
          <DeleteContainer onClick={() => setAreYouSureModal(true)}>
            <DeleteText>Delete FAQ</DeleteText>
            <Delete />
          </DeleteContainer>
        </ModalContainer>
        {isVisible && (
          <>
            <Background $open={areYouSureModal} $bg />
            <SmallModalContainer $open={areYouSureModal}>
              <ModalTitleSmall style={{ textAlign: 'center' }}>
                Are you sure you want to delete this to faq?
              </ModalTitleSmall>
              <ButtonContainerGap style={{ gap: 20 }}>
                <StyledButton onClick={() => setAreYouSureModal(false)}>
                  <ButtonText>Cancel</ButtonText>
                </StyledButton>

                <StyledButton
                  onClick={() => {
                    if (!deleteLoading) {
                      handleDelete(selectedId);
                      setAreYouSureModal(false);
                    }
                  }}
                  $disabled={deleteLoading}
                  $black>
                  {!deleteLoading ? (
                    <ButtonText $black>Yes</ButtonText>
                  ) : (
                    <Waveform size={26} lineWeight={3.5} speed={1} color="white" />
                  )}
                </StyledButton>
              </ButtonContainerGap>
            </SmallModalContainer>
          </>
        )}
      </ModalComponent>
    </Container>
  );
};

export default TemplatesPage;
